export { track, trackException } from "@jupiter/core";
export { init } from "./sdk";

import * as BrowserIntegrations from "./integrations";

const INTEGRATIONS = {
  ...BrowserIntegrations,
};

export { INTEGRATIONS as Integrations };
